import * as React from 'react';
import { Alert } from '@ixicare/ui';
import { IntegrationSlug } from '@ixicare/resources';
import { t } from '~i18n';
import { SectionDivider, SectionTitle } from '~components/Utils/Section';
import { useSiteIntegrations } from '../hooks/useSiteIntegrations';

const INTEGRATION_NAMES: Partial<Record<IntegrationSlug, string>> = {
  [IntegrationSlug.G4S]: 'G4S',
  [IntegrationSlug.VIEDOM]: 'Z-Plus',
  [IntegrationSlug.PCS]: 'PCS',
};

/**
 * The integrations Ixicare sets up for a site, shown so customers know they are live. They are
 * read-only here: their configuration still needs us.
 */
export function SiteManagedIntegrations({ siteUuid }: { siteUuid: string }) {
  const { data: integrations } = useSiteIntegrations(siteUuid);
  const active = (integrations ?? []).filter(
    (integration) => integration.isEnabled && integration.integrationSlug in INTEGRATION_NAMES
  );

  if (active.length === 0) {
    return null;
  }

  return (
    <>
      <SectionDivider />
      <SectionTitle>{t('site.developer.managedIntegrations.title')}</SectionTitle>
      <div className="row">
        <div className="col-12 col-md-6">
          <ul>
            {active.map((integration) => (
              <li key={integration.integrationSlug}>
                {INTEGRATION_NAMES[integration.integrationSlug]}: {t('site.developer.managedIntegrations.active')}
              </li>
            ))}
          </ul>
        </div>
        <div className="col-12 col-md-6">
          <Alert type="message">{t('site.developer.managedIntegrations.description')}</Alert>
        </div>
      </div>
    </>
  );
}
